const initialState = {
  data: {
    Items: [],
  },
  roiData: {
    Items: [],
    TotalInvested: 0,
    TotalReturned: 0,
  },
  trendsData: {
    Periods: [],
    Revenue: [],
    CostOfRevenue: [],
    OperationalCost: [],
    NetProfit: [],
    TotalRevenue: 0,
    TotalCostOfRevenue: 0,
    TotalOperationalCost: 0,
    TotalNetProfit: 0,
  },
  loading: false,
  roiLoading: false,
  trendsLoading: false,
  error: null,
  roiError: null,
  trendsError: null,
};

export const profitabilityMarginsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_PROFITABILITY_MARGINS_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_PROFITABILITY_MARGINS_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case "GET_PROFITABILITY_MARGINS_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "GET_PROFITABILITY_ROI_REQUEST":
      return {
        ...state,
        roiLoading: true,
      };
    case "GET_PROFITABILITY_ROI_SUCCESS":
      return {
        ...state,
        roiLoading: false,
        roiData: action.payload,
        roiError: null,
      };
    case "GET_PROFITABILITY_ROI_FAILURE":
      return {
        ...state,
        roiLoading: false,
        roiError: action.payload,
      };
    case "GET_PROFITABILITY_TRENDS_REQUEST":
      return {
        ...state,
        trendsLoading: true,
      };
    case "GET_PROFITABILITY_TRENDS_SUCCESS":
      return {
        ...state,
        trendsLoading: false,
        trendsData: action.payload,
        trendsError: null,
      };
    case "GET_PROFITABILITY_TRENDS_FAILURE":
      return {
        ...state,
        trendsLoading: false,
        trendsError: action.payload,
      };
    default:
      return state;
  }
};
